import React from 'react';
import PropTypes from 'prop-types';

import { Spacer } from '@ontruck/orc';
import { Icon } from '@ontruck/orc';

const TopLoadCell = ({ topLoadNeeded, ...props }) => {
  return (
    topLoadNeeded && (
      <Spacer {...props}>
        <Icon size="3.2rem" glyph="extras-retractableroof" color="grey500" />
      </Spacer>
    )
  );
};

TopLoadCell.propTypes = {
  topLoadNeeded: PropTypes.bool,
};

export default TopLoadCell;
